/**
 * 値が null / undefined の項目を除いた新しいオブジェクトを返す（1 階層だけ。空文字・0・false は残す）。
 * URLSearchParams.append は null を文字列 "null" にして送るので、API に渡す前にこれを通す
 */
export function omitNullish(source) {
  const result = {};
  for (const key of Object.keys(source)) {
    if (source[key] !== null && source[key] !== undefined) result[key] = source[key];
  }
  return result;
}
